// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import skillRuleEntity from './entities/skill-rule.json';
import skillRuleMenu from '../pages/skill-rule/menu.json';
import skillRuleFullForm from '../pages/skill-rule/forms/full.json';
import skillRuleContextForm from '../pages/skill-rule/forms/context.json';
import skillRuleMiniForm from '../pages/skill-rule/forms/mini.json';
import skillRuleLookupForm from '../pages/skill-rule/forms/lookup.json';
import skillRuleTableView from '../pages/skill-rule/views/table.json';
import skillRuleCardsView from '../pages/skill-rule/views/cards.json';
import skillRuleDashboardView from '../pages/skill-rule/views/dashboard.json';

/** Тип запису «Правило» зі сторінками пакета: меню, форми та подання з pages/skill-rule/. */
export const skillRuleDefinition: IRecordTypeDefinition = {
  ...skillRuleEntity,
  views: assembleViewSet({
      table: skillRuleTableView,
      cards: skillRuleCardsView,
      dashboard: skillRuleDashboardView,
  }),
  form: skillRuleFullForm,
  forms: { full: skillRuleFullForm, context: skillRuleContextForm, mini: skillRuleMiniForm, lookup: skillRuleLookupForm },
  menu: skillRuleMenu,
} as IRecordTypeDefinition;
